<div class="row">
    <div class="col-md-12">
        <p-tabView [(activeIndex)]="selectedTabIndex">
            <p-tabPanel *ngFor="let tab of config" [header]="tab.title">
                <div *ngFor="let item of tab.items">
                    <cv-form-field [options]="{
                        path: item.path
                    }"></cv-form-field>
                </div>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>